import base from "./base"; // 导入接口域名列表
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块
const getDz = {
  // getQueryRecordList(params) {
  //   return axios.post(`${base.bd}/mobile/ship/log_lists2`, qs.stringify(params));
  // },
  get_addresslist(params) {
    return axios.post("/api/common/ad/lists_one", qs.stringify(params));
  },
  postApply(params) {
    return axios.post("/api/mobile/enroll/apply", qs.stringify(params));
  },
  postUserLogin(params) {
    return axios.post("/api/mobile/power/validate_username", qs.stringify(params));
  },
  postUserCode(params) {
    return axios.post("/api/mobile/power/sendcode", qs.stringify(params));
  },
  usernameRegister(params) {
    return axios.post("/api/mobile/power/user_reg", qs.stringify(params));
  },
  userLogin(params) {
    return axios.post("/api/mobile/power/user_login", qs.stringify(params));
  },
  getUserFormDetail(params) {
    return axios.post("/api/mobile/enroll/find_apply", qs.stringify(params));
  },
  getConfig(params) {
    return axios.post("/api/mobile/config/find_iden", qs.stringify(params));
  },
  getNumber(params) {
    return axios.post("/api/mobile/enroll/get_apply_num", qs.stringify(params));
  },


  page_city(params) {
    return axios.post("/api/mobile/page/city", qs.stringify(params));
  },
  page_office(params) {
    return axios.post("/api/mobile/page/office", qs.stringify(params));
  },

  enroll_change_exam(params) {
    return axios.post("/api/mobile/enroll/change_exam", qs.stringify(params));
  },


  getIdCardToage(params) {
    return axios.post("/api/mobile/enroll/idcardtoage", qs.stringify(params));
  },

  enroll_entrance(params) {
    return axios.post("/api/mobile/enroll/entrance", qs.stringify(params));
  },

  enroll_check2(params) {
    return axios.post("/api/mobile/enroll/check2", qs.stringify(params));
  },


};
export default getDz;
